var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',_vm._b({attrs:{"background":"","small":_vm.paginationSize === 'small',"current-page":_vm.currentPage,"page-size":_vm.pageSize},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange,"prev-click":_vm.prevClick,"next-click":_vm.nextClick}},'el-pagination',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }